import axios from 'axios';
import { GlobalErrorActions } from 'actions'

// To override the global error getting set, use axios as such:
// axios.get("something", { catchErrors: false }
// or
// axios.post("something", {}, { catchErrors: false }
// This is important when the error is manually handled (as it should be, generally)
const catchErrors = (config) => {
  if (!config.hasOwnProperty('catchErrors')) return true // default
  return config.catchErrors
}

const errorHandler = (error) => {
  if (catchErrors(error.config)) {
    if ((error.status != 422) && (error.config.url.indexOf('healthcheck') == -1)) {
      // 422 errors should be handled by the individual handlers, everything else we can assume is not handled
      GlobalErrorActions.setGenericGlobalError()
    }
  }
  return Promise.reject(error)
}

axios.interceptors.response.use(
  response => response,
  error => errorHandler(error)
)



// WEBPACK FOOTER //
// ./app/utils/GlobalErrorUtils.js